import React from 'react'
import { Button } from '@material-ui/core'
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon
} from '@material-ui/icons'

/**
 * Custom pagination component compatible with Material-UI v4
 */
const CustomPagination = ({ count, page, onChange, color = "primary" }) => {
  const totalPages = Math.ceil(count)
  const maxVisible = 5
  const startPage = Math.max(1, page - Math.floor(maxVisible / 2))
  const endPage = Math.min(totalPages, startPage + maxVisible - 1)

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      onChange(null, newPage)
    }
  }

  const renderPageNumbers = () => {
    const pages = []
    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <Button
          key={i}
          variant={i === page ? "contained" : "outlined"}
          color={color}
          size="small"
          onClick={() => handlePageChange(i)}
          style={{ margin: '0 2px', minWidth: '32px' }}
        >
          {i}
        </Button>
      )
    }
    return pages
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 8 }}>
      <Button
        variant="outlined"
        color={color}
        size="small"
        disabled={page <= 1}
        onClick={() => handlePageChange(page - 1)}
      >
        <ChevronLeftIcon />
      </Button>
      
      {renderPageNumbers()}
      
      <Button
        variant="outlined"
        color={color}
        size="small"
        disabled={page >= totalPages}
        onClick={() => handlePageChange(page + 1)}
      >
        <ChevronRightIcon />
      </Button>
    </div>
  )
}

export default CustomPagination


// WEBPACK FOOTER //
// ./src/features/tours/components/CustomPagination.js